<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :show="true"
    width="28%"
    @confirm="confirm"
    @closeDialog="close"
  >
    <el-form label-width="100px">
      <el-form-item label="公众号：">
        <el-input
          v-if="flag === 2"
          :placeholder="currentRowData.account_name"
          disabled
        />
        <el-select
          v-if="flag === 1"
          v-model.trim="form.wechat_account_id"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in selectData.auth_wechat"
            :key="item.id"
            :label="item.account_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="option1.title + ':'">
        <el-select
          v-model="form.user_id"
          placeholder="请选择"
          filterable
        >
          <el-option
            v-for="item in selectData.userList"
            :key="item.id"
            :label="item[option1.label]"
            :value="item[option1.value]"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间：">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOption"
          @change="pickerTime"
        />
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow'
import moment from 'moment'
export default {
  name: 'AddWechatUser',
  components: { GlobalWindow },
  props: {
    // 获取父组件筛选列表
    selectData: {
      type: Object,
      default() {
        return {}
      }
    },
    title: {
      type: String,
      default: '添加'
    },
    option1: {
      type: Object,
      default() {
        return {
          label: 'name',
          value: 'id',
          title: '用户'
        }
      }
    }
  },
  data() {
    return {
      currentRowData: {},
      visible: false,
      timeValue: null,
      // 收集表单数据
      form: {
        user_id: null, // 用户id
        wechat_account_id: null, // 公众号id
        start_time: null,
        end_time: null
      },
      pickerOption: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000 // > 是选择今天之前的时间  < 是选择今天之后 都包括今天的时间
        }
      },
      flag: null // 判断公众号使用 输入框 还是 选择框
    }
  },
  methods: {
    open(data, flag) {
      this.visible = true
      this.flag = flag
      this.currentRowData = data // 获取当前行的数据
      this.form.wechat_account_id = data.wechat_account_id // 获取当前行的公众号ID
    },
    // 关闭dialog
    close() {
      this.form = {}
      this.timeValue = null
    },
    // 确认按钮
    confirm() {
      if (!this.form.user_id || !this.form.wechat_account_id || !this.form.start_time || !this.form.end_time) {
        this.$message({
          message: '任一添加项不能为空',
          type: 'error'
        })
        return
      }
      this.$emit('confirm', this.form)
      this.form = {}
      this.timeValue = null
      this.visible = false
    },
    // 选择时间
    pickerTime() {
      this.form.start_time = moment(this.timeValue[0]).format('YYYY-MM-DD')
      this.form.end_time = moment(this.timeValue[1]).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>
</style>
